// src/redux/locationSlice.js

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// Async thunk for fetching the current location
export const fetchCurrentLocation = createAsyncThunk(
  'location/fetchCurrentLocation',
  async (_, thunkAPI) => {
    if (!navigator.geolocation) {
      return thunkAPI.rejectWithValue('Geolocation is not supported by your browser');
    }
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          resolve({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          });
        },
        (error) => {
          reject(thunkAPI.rejectWithValue(error.message));
        }
      );
    });
  }
);

const locationSlice = createSlice({
  name: 'location',
  initialState: {
    latitude: null,
    longitude: null,
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCurrentLocation.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchCurrentLocation.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.latitude = action.payload.latitude;
        state.longitude = action.payload.longitude;
      })
      .addCase(fetchCurrentLocation.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
  },
});

export default locationSlice.reducer;
